import jonas from "./Jonas_Itt.png";
import jakob from "./Jakob_Guenther.png";
import nhat from "./Nhat_Quynh_Nguyen.png";

const teamConfig = [
  {
    picture: jonas,
    name: "Jonas Itt",
    role: "Frontend and Design",
    studies: "Computer Science",
  },
  {
    picture: jakob,
    name: "Jakob Günther",
    role: "Backend",
    studies: "Computer Science",
  },
  {
    picture: nhat,
    name: "Nhat Quynh Nguyen",
    role: "Design, Pitch",
    studies: "Mechanical Engineering",
  },
];

export default teamConfig;
